export default "__VITE_ASSET__C5vGo0wL__"